import React from 'react'

import { useColor } from '../../../kiti/components/theme/_hooks/colors'
import { useElementStyle, useLeafStyle } from './styles'
import FontSizePlugin from './FontSizePlugin'
import ImagePlugin from './ImagePlugin'
import ImagesInterpolationPlugin from './ImagesInterpolationPlugin'
import InterpolationPlugin from './InterpolationPlugin'
import LinkPlugin from './LinkPlugin'
import ListPlugin from './ListPlugin'
import QuotePlugin from './QuotePlugin'
import RawInterpolationPlugin from './RawInterpolationPlugin'
import SeparatorPlugin from './SeparatorPlugin'

const DefaultLeaf = props => {
  const color = useColor('dark2')
  const style = useLeafStyle(props)

  return (
    <span style={style} {...props.attributes}>
      {props.children}
    </span>
  )
}
export const renderLeaf = props => {
  return <DefaultLeaf {...props} />
}

const DefaultElement = props => {
  return (
    <p {...props.attributes} style={{ margin: 0, padding: 0, ...useElementStyle(props.element) }}>
      {props.children}
    </p>
  )
}

export const renderElement = props => {
  switch (props.element.type) {
    case 'list_item':
      return <ListPlugin.ItemElement {...props} />
    case 'list':
      return <ListPlugin.Element name="list" {...props} />
    case 'numered_list':
      return <ListPlugin.Element name="numered_list" {...props} />
    case 'quote':
      return <QuotePlugin.Element {...props} />
    case 'h1':
      return <FontSizePlugin.Element name="h1" {...props} />
    case 'h2':
      return <FontSizePlugin.Element name="h2" {...props} />
    case 'h3':
      return <FontSizePlugin.Element name="h3" {...props} />
    case 'small':
      return <FontSizePlugin.Element name="small" {...props} />
    case 'link':
      return <LinkPlugin.Element {...props} />
    case 'raw_interpolation':
      return <RawInterpolationPlugin.Element {...props} />
    case 'interpolation':
      return <InterpolationPlugin.Element {...props} />
    case 'images_interpolation':
      return <ImagesInterpolationPlugin.Element {...props} />
    case 'image':
      return <ImagePlugin.Element {...props} />
    case 'separator':
      return <SeparatorPlugin.Element {...props} />
    default:
      return <DefaultElement {...props} />
  }
}
